import React from 'react';
import { Container, Grid, Typography, Card, CardContent, Box } from '@mui/material';
import { useTheme } from '../context/context';
import { NavLink } from 'react-router-dom';
// import './style.css'

export default function AutoScroll({ heading, contents }) {
  const { fontSize } = useTheme();

  return (
    <Box sx={{ boxShadow:"0 0 3px 0px gray", borderRadius:"4px"}} >
      
        <Container style={{background:"#0b4285", color:"white", minHeight:"30px", padding:" 10px 5px", textAlign:"center"}}>
          <Typography variant="h5" sx={{ fontSize: `${fontSize}rem`, margin:0 }}>
            {heading}
          </Typography>
        </Container>
        <Card sx={{  overflowY: 'auto', margin:"0", height:"200px" }}>
          <CardContent sx={{padding:"0", textDecoration:"underline"}}>
            <ul>
            {contents.map((data, index) => (
              // <NavLink
              //   to="/"
              //   key={index}
              //   style={{
              //     textDecoration: 'none',
              //     color: 'teal',
              //     fontSize: `${fontSize-0.1}rem`,
              //     display: 'block',
              //     transition: 'color 0.3s ease-in-out',
              //   }}
              //   activeStyle={{ color: 'blue' }}
              // >
                <li>{data}</li>
              // </NavLink>
            ))}
            </ul>
          </CardContent>
        </Card>
    </Box>
  );
}
